import {
    GET_APPEARANCE_BACKGROUNDS_SUCCESS,
    UPLOAD_APPEARANCE_BACKGROUND,
    UPLOAD_APPEARANCE_BACKGROUND_SUCCESS,
    UPLOAD_APPEARANCE_BACKGROUND_FAILURE,
    DELETE_APPEARANCE_BACKGROUND,
    DELETE_APPEARANCE_BACKGROUND_SUCCESS,
} from "./constants";

const initialState = {
    loading: false,
    backgrounds: [],
    error: null,
};

const appearanceBackground = (state = initialState, action) => {
    switch (action.type) {
        case GET_APPEARANCE_BACKGROUNDS_SUCCESS:
            return { ...action.backgrounds, backgrounds: action.backgrounds };
        case UPLOAD_APPEARANCE_BACKGROUND:
            return { ...state, loading: true, error: null };
        case UPLOAD_APPEARANCE_BACKGROUND_SUCCESS:
            return {
                ...state,
                loading: false,
                backgrounds: [action.payload, ...state.backgrounds],
                error: null,
            };
        case UPLOAD_APPEARANCE_BACKGROUND_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case DELETE_APPEARANCE_BACKGROUND:
            return { ...state, error: null };
        case DELETE_APPEARANCE_BACKGROUND_SUCCESS:
            return {
                ...state,
                backgrounds: state.backgrounds.filter(
                    (background) => background.id != action.payload
                ),
            };
        default:
            return state;
    }
};

export default appearanceBackground;
